<script setup lang="ts">
    const route = useRoute()

    const authStore = useAuthStore()
    const notificationStore = useNotificationStore()

    const isAuthenticated = computed(() => authStore.isAuthenticated)
    const unreadCount = computed(() => notificationStore.unreadCount)

    const tabs = computed(() => {
        return [
            {
                label: 'Start',
                icon: 'mdi-home',
                to: { name: 'login' },
                display: !isAuthenticated.value,
                badge: 0
            },
            {
                label: 'Start',
                icon: 'mdi-home',
                to: { name: 'dashboard' },
                display: isAuthenticated.value,
                badge: 0
            },
            {
                label: 'Verlauf',
                icon: 'mdi-bell',
                to: { name: 'inbox' },
                display: isAuthenticated.value,
                badge: unreadCount.value
            },
            {
                label: 'Einstellungen',
                icon: 'mdi-cog',
                to: { name: 'settings' },
                display: isAuthenticated.value,
                badge: 0
            },
            {
                label: 'Abmelden',
                icon: 'mdi-logout',
                to: { name: 'logout' },
                display: isAuthenticated.value,
                badge: 0
            }
        ]
    })

    const active = ref(route.path)

    watch(
        () => route.name,
        (newName) => {
            active.value = newName as string
        }
    )

    watch(
        isAuthenticated,
        async (isAuth) => {
            if (!isAuth) return
            try {
                await notificationStore.fetchInbox()
            } catch (e) {
                console.error('Inbox-Fetch fehlgeschlagen', e)
            }
        },
        { immediate: true }
    )
</script>

<template>
    <v-bottom-navigation v-model="active" height="64" app>
        <template v-for="tab in tabs" :key="tab.to.name">
            <v-btn
                v-if="tab.display"
                :value="tab.to.name"
                variant="text"
                :to="tab.to"
                :data-test="tab.label"
                :text="tab.label"
            >
                <v-badge
                    v-if="tab.badge > 0"
                    :content="tab.badge"
                    color="error"
                    offset-x="-2"
                    offset-y="2"
                >
                    <v-icon>{{ tab.icon }}</v-icon>
                </v-badge>
                <v-icon v-else>{{ tab.icon }}</v-icon>
                <span class="text-caption">{{ tab.label }}</span>
            </v-btn>
        </template>
    </v-bottom-navigation>
</template>

<style scoped></style>
